export default __webpack_public_path__ + "static/media/EB23D8A7-609B-4458-87C0-6CA2982D1534_1_105_c.4e5bf1da.jpeg";